import React, { FC } from 'react'

interface PaginationI {
  currentPage: number
  totalPages: number
  maxPages: number
}

interface PaginationButtonI {
  start: number
  end: number
}

const Pagination: FC<PaginationI> = ({ currentPage, totalPages, maxPages }) => {
  let startPage
  let endPage
  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    startPage = 1
    endPage = totalPages
  } else {
    // total pages more than max so calculate start and end pages
    const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2)
    const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      startPage = 1
      endPage = maxPages
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      startPage = totalPages - maxPages + 1
      endPage = totalPages
    } else {
      // current page somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage
      endPage = currentPage + maxPagesAfterCurrentPage
    }
  }

  const PreviousButton = () => (
    <a href={currentPage === 2 ? '/' : `${currentPage - 1}`} className="previous">
      Prev
    </a>
  )

  const NextButton = () => (
    <a href={currentPage === 1 ? 'page/2' : `${currentPage + 1}`} className="next">
      Next
    </a>
  )

  const PaginationButtons: FC<PaginationButtonI> = ({ start, end }) => (
    <React.Fragment>
      {Array.from({ length: end - start + 1 })
        .map((_, i) => start + i)
        .map((pos) => {
          return (
            <a
              href={pos === 1 ? '/' : currentPage !== 1 ? `${pos}` : `page/${pos}`}
              key={pos}
              className={currentPage === pos ? 'page active' : 'page'}
            >
              {pos}
            </a>
          )
        })}
    </React.Fragment>
  )

  // const EllipsisButton = () => <span className="extra">&hellip;</span>

  return (
    <footer>
      <div className="pagination">
        {currentPage !== 1 && <PreviousButton />}
        <PaginationButtons start={startPage} end={endPage} />
        {currentPage !== totalPages && <NextButton />}
      </div>
    </footer>
  )
}

export default Pagination
